import { Box, Modal, Typography } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

import StarRating from "./StarRating";

interface StarsRatingGuideCardProps {
  setShowStarsRatingGuide: (value: boolean) => void;
  isOpen: boolean;
}

const TableRow = styled(Box)`
  border-bottom: 1px dashed #f0f0f0;
`;

const TableHeader = styled(TableRow)`
  height: 120px;
  margin-top: -8px;
  @media screen and (max-width: 414px) {
    height: 120px;
  }
  @media screen and (min-width: 415px) and (max-width: 1024px) {
    height: 100px;
  }
  @media screen and (min-width: 1025px) {
    height: 80px;
  }
`;

const ScrollableModal = styled(Modal)`
  max-height: 82%;
  overflow-y: auto;
  :focus {
    outline: none;
  }
`;

const StarsRatingGuideCard: React.FunctionComponent<StarsRatingGuideCardProps> =
  ({ setShowStarsRatingGuide, isOpen }) => {
    const ratingDescriptions = [
      ["5.0", "Exceeds 16%"],
      ["4.5", "Exceeds 14%"],
      ["4.0", "Exceeds 12%"],
      ["3.5", "Exceeds 10%"],
      ["3.0", "Exceeds 8%"],
      ["2.5", "Exceeds 6%"],
      ["2.0", "Exceeds 4%"],
      ["1.5", "Exceeds 2%"],
      ["1.0", "Less than 2%"],
    ];

    return (
      <ScrollableModal
        isOpen={isOpen}
        role="dialog"
        isDismissable={true}
        overlayVariant="dark"
        onClose={() => setShowStarsRatingGuide(false)}
      >
        <Box
          width={{ mobile: "182px", tablet: "300px", desktop: "300px" }}
          height={{ mobile: "48px", tablet: "24px", desktop: "24px" }}
          marginTop="-40px"
        >
          <Typography variant="h5">HPI Spec Check Options Rating</Typography>
        </Box>
        <Box
          width={{ mobile: "263px", tablet: "394px", desktop: "587px" }}
          height={{ mobile: "auto", tablet: "54px", desktop: "36px" }}
          marginTop="30px"
        >
          <Typography variant="body" color="#374d62">
            This is a measure of the value of factory fitted optional equipment
            compared to the base price of the vehicle when it was new.
          </Typography>
        </Box>
        <Box>
          <TableHeader
            display="flex"
            flexDirection="row"
            margin="10px 1px 10px 0"
          >
            <Box width="89px" height="19px">
              <Typography variant="h6">Rating</Typography>
            </Box>
            <Box
              width={{ mobile: "212px", tablet: "308px", desktop: "484px" }}
              height={{ mobile: "57px", tablet: "38px", desktop: "19px" }}
            >
              <Typography variant="h6" mb="5px">
                Optional Equipment total compared to vehicle base price when new
              </Typography>
            </Box>
          </TableHeader>
          {ratingDescriptions.map((ratingDesc) => (
            <TableRow
              key={"rating" + ratingDesc[0]}
              display="flex"
              flexDirection="row"
              margin="10px 1px 10px 0"
              height="28px"
            >
              <Box width="89px" marginTop="0px">
                <StarRating variant="small" rating={ratingDesc[0]} />
              </Box>
              <Box width="212px" marginTop="-18px">
                <Typography variant="body" color="#374d62">
                  {ratingDesc[1]}
                </Typography>
              </Box>
            </TableRow>
          ))}
        </Box>
      </ScrollableModal>
    );
  };

export default StarsRatingGuideCard;
